import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, Output } from "@angular/core";
import { isNotNullOrUndefined } from "@pcp/core/util";
import { distinctUntilChanged, map, Observable, take } from "rxjs";
import {
    DIFFICULT_QUESTION_ELEMENT_ENET_TOKEN,
    DIFFICULT_QUESTION_ELEMENT_IS_MAIN_CLIENT,
    DIFFICULT_QUESTION_ELEMENT_LANGUAGE_CODE,
    DIFFICULT_QUESTION_ELEMENT_MUTE_AUDIO,
    VOTING_ELEMENT_BASE_URL,
} from "../difficult-question-element/injection-tokens";
import { AsyncPipe } from "@angular/common";
import { EmmIframeComponent } from "shared/classroom/preview-screen/slide-rendering/ui";

export interface VotingElementElementProps {
    votingElementId: number;
    guid: string;
    presentationId?: string;
    loginCode: string;
}

@Component({
    selector: 'pcp-voting-element',
    templateUrl: './voting-element.component.html',
    styleUrls: ['./voting-element.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [EmmIframeComponent, AsyncPipe]
})
export class VotingElementComponent {
    iframeSrc$: Observable<string>;

    @Output() showVideo = new EventEmitter<number>();

    private readonly votingElementBaseSrc = inject(VOTING_ELEMENT_BASE_URL);
    private readonly difficultQuestionElementIsMainClient = inject(DIFFICULT_QUESTION_ELEMENT_IS_MAIN_CLIENT);
    private readonly difficultQuestionElementMuteAudio = inject(DIFFICULT_QUESTION_ELEMENT_MUTE_AUDIO);
    private readonly languageCode = inject(DIFFICULT_QUESTION_ELEMENT_LANGUAGE_CODE);
    private readonly enetToken$ = inject(DIFFICULT_QUESTION_ELEMENT_ENET_TOKEN);

    @Input() set difficultQuestionElement(
        elementProps: VotingElementElementProps
    ) {
        this.iframeSrc$ = this.enetToken$.pipe(
            distinctUntilChanged(),
            map((enetToken) => {
                if (!isNotNullOrUndefined(enetToken)) {
                    throw 'Unable to render difficultQuestion element: enetToken is undefined';
                }

                // https://questionservice.fahren-lernen.de/api/WebFiles/Voting?LanguageKey=DE&Authorization=e46ca09c4093e768abb16ff50ff67e6026a9847bd9adbf1771991a31ad5c23e3&GUID=82c143ef-5e27-40d5-a351-1cf6920776ce&IsMainClient=true&MuteAudio=false

                let url = `${this.votingElementBaseSrc}?VotingElement=${elementProps.votingElementId}&LoginCode=${elementProps.loginCode}&LanguageKey=${this.languageCode}&Authorization=${enetToken}&GUID=${elementProps.guid}&IsMainClient=${this.difficultQuestionElementIsMainClient}&MuteAudio=${this.difficultQuestionElementMuteAudio}`;
                if (elementProps.presentationId) {
                    url += `&PresentationId=${elementProps.presentationId}`;
                }

                return url;
            }),
            take(1) // url will _not_ update automatically if the token changes
        );
    }

    onMessageFromIframe(message: string) {
        if (message.startsWith('PCP-VIDEO')) {
            const [eventName, videoId] = message.split('|');
            this.showVideo.next(Number(videoId));
        }
    }
}
